"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.settings.title': 'Abrir Configuración',
    'shortcuts.settings.description': 'Abre el panel de configuración para ajustar tus preferencias',
};
